import gql from 'graphql-tag';

export const GET_TIER_PERFORMANCE_STATS_FOR_OFFER = gql`
  query GetTierPerformanceStatsForOffer($offerId: Int!, $useNewTierStats: Boolean = false) {
    getTierPerformanceStatsForOffer(offerId: $offerId, useNewTierStats: $useNewTierStats) {
      automationType
      automationThreshold
      offerPayout {
        id
        label
        flatPayout
        percentPayout
      }
      totalMembersInTier
      newMembersInTier
    }
  }
`;
export const GET_BOOSTS_PERFORMANCE_STATS_FOR_OFFER = gql`
  query GetBoostsPerformanceStatsForOffer($endDate: DateTime, $startDate: DateTime, $offerId: Int!) {
    boostPerformances(endDate: $endDate, startDate: $startDate, offerId: $offerId) {
      affiliatesRewarded
      boostId
      boostType
      cost
      offerId
      pendingRewards
      redeemedRewards
      startDate
      value
    }
  }
`;
